import httpService from '../../../services/httpService';
const UnexpectedStockOutflowStatusRepository = require('../domain/unexpectedStockOutflowStatusRepository');
const UnexpectedStockOutflowStatus = require('../domain/UnexpectedStockOutflowStatus');

export default class RemoteUnexpectedStockOutflowStatusRepository extends UnexpectedStockOutflowStatusRepository {
    constructor(httpClient) {
        super();
        this.httpClient = httpService;
    }

    async getAll() {
        const {data} = await this.httpClient.get('/unexpected-outflows/statuses');
        return data.data.map(item => 
            new UnexpectedStockOutflowStatus(
                item.Id,
                item.estatus
            )
        );
    }
}
